/* import __COLOCATED_TEMPLATE__ from './quiet-hours.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    isEnabled: boolean;
    isDraft: boolean;
    startTime: string;
    endTime: string;
    timeOptions: { value: string; text: string }[];
    hasValidationError: boolean;
    onToggle: () => void;
    onStartChange: (value: string) => void;
    onEndChange: (value: string) => void;
  };
}

const QuietHours = templateOnlyComponent<Signature>();
export default QuietHours;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::OutboundCampaignEditPanel::QuietHours': typeof QuietHours;
  }
}
